// Grab all of the product buy box options
const productBuyBoxOptions = document.querySelectorAll('.product-option');
productBuyBoxOptions.forEach((productBuyBoxOption) => {
  productBuyBoxOption.addEventListener('click', () => {
    // Add event listener to them so we can track which variants are changes and update the atc sticky bar.
    const optionSelectedInput = productBuyBoxOption.querySelector('input');

    const optionToSelectValue = optionSelectedInput.value;
    const optionToSelectType = optionSelectedInput.name;
    const optionToSelect = document.querySelector(`.add-to-cart-bar .option-select[name="options[${optionToSelectType}]"]`);

    if (optionToSelect) {
      optionToSelect.value = optionToSelectValue;
      optionToSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
});

// Grab the sticky add to cart options
const productStickyAtcOptions = document.querySelectorAll('.add-to-cart-bar .option-select');
productStickyAtcOptions.forEach((productStickyAtcOption) => {
  productStickyAtcOption.addEventListener('change', () => {
    // Add change event listener to them so we can track which variants are changes and update the buy box options.
    const optionToSelectValue = productStickyAtcOption.value;
    const optionToSelectType = productStickyAtcOption.dataset.optionName;
    const optionToSelect = document.querySelector(`.product-option input.product-option__${optionToSelectType}[value="${optionToSelectValue}"]`);

    if (optionToSelect) {
      optionToSelect.checked = true;
      optionToSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update the add-to-cart bar button based on variant availability
    updateAddToCartBarButton();
  });
});

// Function to update the add-to-cart bar button state
function updateAddToCartBarButton() {
  const addToCartBarButton = document.querySelector('[data-add-to-cart-bar-button]');
  const addToCartBarButtonText = document.querySelector('[data-add-to-cart-bar-text]');
  const addToCartBarSelects = document.querySelectorAll('.add-to-cart-bar .option-select');
  
  if (!addToCartBarButton || !addToCartBarButtonText) return;

  // Get selected options from add-to-cart bar
  const selectedOptions = Array.from(addToCartBarSelects).map(select => select.value);
  
  // Get variant data from the main product form
  const variantSelectsEl = document.querySelector('variant-selects[data-section]');
  if (!variantSelectsEl) return;
  
  const variantData = JSON.parse(variantSelectsEl.querySelector('[type="application/json"]').textContent);
  
  // Find the matching variant
  const currentVariant = variantData.find((variant) => {
    return !variant.options.map((option, index) => {
      return selectedOptions[index] === option;
    }).includes(false);
  });

  // Update button state based on variant availability
  if (currentVariant && currentVariant.available) {
    addToCartBarButton.removeAttribute('disabled');
    addToCartBarButtonText.textContent = window.variantStrings?.addToCart || 'Add to Cart';
  } else {
    addToCartBarButton.setAttribute('disabled', 'disabled');
    addToCartBarButtonText.textContent = window.variantStrings?.soldOut || 'Sold Out';
  }
}

// Listen to changes from the main variant selector to update the add-to-cart bar
const mainVariantSelects = document.querySelector('variant-selects[data-section]');
if (mainVariantSelects) {
  mainVariantSelects.addEventListener('change', (event) => {
    // Get all select elements in the main form
    const mainSelects = mainVariantSelects.querySelectorAll('select');
    
    // Update the add-to-cart bar selects to match
    mainSelects.forEach((mainSelect) => {
      const optionName = mainSelect.name.match(/options\[(.*?)\]/)?.[1];
      if (optionName) {
        const barSelect = document.querySelector(`.add-to-cart-bar .option-select[name="options[${optionName}]"]`);
        if (barSelect && barSelect.value !== mainSelect.value) {
          barSelect.value = mainSelect.value;
        }
      }
    });
    
    // Update button state
    updateAddToCartBarButton();
  });
}

// Initial button state update on page load
document.addEventListener('DOMContentLoaded', () => {
  updateAddToCartBarButton();
});